export default __webpack_public_path__ + "static/media/wallet.5bf7c07e.svg";